/* THIS FILE IS GENERATED ON RUNTIME. DO NOT EDIT */

module.exports = require("../../sites/hant/tailwind.js");